import { render } from "./RoomActions.vue?vue&type=template&id=b8592128"
import script from "./RoomActions.vue?vue&type=script&lang=js"
export * from "./RoomActions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__